import { useStateMachine } from 'little-state-machine';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { FormGroup } from '../../../../../Components/FormGroup/FormGroup';
import { StyledFormGroup } from '../../../../../Components/Reuseables';
import { fetchWrapper } from '../../../../../_helpers/fetchWrapper';
import { ErrorMessageHandler } from '../../../../../_helpers/_methods';
import updateAction from './updateAction';
import { FormattedMessage } from 'react-intl';
import clearStore from './clearStore';
import { useSelector } from 'react-redux';
import NavigationButtonGroup from '../../../../admin/Events/Steps/components/NavigationButtonGroup';

function OrganizationStep5() {
  const user = useSelector((state) => state.user.user);
  // const {edit:isEdit} = useParams();
  const lang = useSelector((state) => state?.local?.local);
  const rosterData = useSelector((state) => state.rosters.rosters);
  const [isLoading, setIsLoading] = useState(false);

  const { actions } = useStateMachine({ updateAction, clearStore });
  const { state } = useStateMachine({ updateAction });
  const navigate = useNavigate();
  const { id, edit: isEdit } = useParams();

  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm({
    mode: 'onBlur',
    defaultValues: {}
  });

  const location = useLocation();
  const onSubmit = async (data) => {
    actions.updateAction(data);
    var document_id = isEdit
      ? rosterData.documents.map((item) => item.id)
      : [
          state.company_registration_document_resource_file[0],
          state.pan_registration_resource_file[0]
        ];
    let body = {
      fullname: state.fullname,
      username: state.email,
      email: state.email,
      phone: state.roster_organization_phone_num,
      type: 'department',
      password: 'password',
      pan: state.roster_organization_pan_number,
      address_id: state?.address_id || '',
      province: state.rosters_organization_physical_location_details?.province?.value,
      district: state.rosters_organization_physical_location_details?.district?.value,
      municipality: state.rosters_organization_physical_location_details?.local_level?.value,
      ward: state.rosters_organization_physical_location_details?.ward,
      tole: state.rosters_organization_physical_location_details?.tole,
      is_public: data.roster_profile_public === 'yes' ? true : false,
      documents: document_id.concat(state.other_resource_file),
      remarks: state.organization_remarks,

      department: {
        fullname: state.fullname,
        work_experience: state.roster_organization_experience
      },
      expertises: state.thematicArea?.map((thematic_area) => {
        return isEdit
          ? {
              id:
                rosterData?.expertises?.find((item) => +item.thematic_area === +thematic_area?.id)
                  .id === 'undefined'
                  ? ''
                  : rosterData?.expertises?.find(
                      (item) => +item.thematic_area === +thematic_area?.id
                    ).id,
              thematic_area: thematic_area.id,
              year: 0,
              training_taken: 0,
              training_given: 0
            }
          : { thematic_area: thematic_area.id, year: 0, training_taken: 0, training_given: 0 };
      }),
      priorities: isEdit
        ? [
            { province: state.priority_first?.value, level: 0 },
            { province: state.priority_second?.value, level: 1 },
            { province: state.priority_third?.value, level: 2 },
            { province: state.priority_fourth?.value, level: 3 },
            { province: state.priority_fifth?.value, level: 4 },
            { province: state.priority_sixth?.value, level: 5 },
            { province: state.priority_seventh?.value, level: 6 }
          ].map((item) => ({
            ...item,
            id: rosterData.priorities.find((rosterItem) => +item.level === +rosterItem.level).id
          }))
        : [
            { province: state.priority_first?.value, level: 0 },
            { province: state.priority_second?.value, level: 1 },
            { province: state.priority_third?.value, level: 2 },
            { province: state.priority_fourth?.value, level: 3 },
            { province: state.priority_fifth?.value, level: 4 },
            { province: state.priority_sixth?.value, level: 5 },
            { province: state.priority_seventh?.value, level: 6 }
          ]
    };

    if (body.phone === rosterData?.user?.phone) {
      delete body.phone;
    }
    try {
      setIsLoading(true);
      isEdit
        ? await fetchWrapper.patch(`/profile/resource-person/${id}/`, body)
        : await fetchWrapper.post('/profile/resource-person/', body);

      actions.clearStore();
      setIsLoading(false);
      let path = location.pathname.split('/');

      if (isEdit) {
        navigate(`/admin/rosters/organization_list`);
      } else if (['superuser', 'cd_admin', 'executive'].includes(user?.active_role)) {
        navigate('/admin/rosters/organization_list');
      } else {
        path.includes('admin')
          ? navigate(`/admin/instructions/roster/${state.email}`)
          : navigate(`/instructions/roster/${state.email}`);
      }
      toast.success(<FormattedMessage id="form_submit_successful" />);
    } catch (error) {
      ErrorMessageHandler(error);
      setIsLoading(false);
    }
  };
  return (
    <div className="my-4">
      <form onSubmit={handleSubmit(onSubmit)}>
        <div>
          <h3 className="">
            <FormattedMessage id="public_profile" />
          </h3>
        </div>
        <div className="row">
          <div className="col-md-12 my-4">
            <StyledFormGroup>
              <FormGroup
                type="radio"
                id="roster_profile_public"
                register={register}
                error={errors}
                label={<FormattedMessage id="make_profile_public" />}
                options={[
                  {
                    label: lang === 'ne' ? 'चाहन्छु' : 'Yes',
                    value: 'yes',
                    id: 'roster_profile_public_yes',
                    name: 'roster_profile_public'
                  },
                  {
                    label: lang === 'ne' ? 'चाहन्न' : 'No',
                    value: 'no',
                    id: 'roster_profile_public_no',
                    name: 'roster_profile_public'
                  }
                ]}
              />
            </StyledFormGroup>
          </div>
        </div>
        <div className="">
          <hr />
          <NavigationButtonGroup
            isSubmit={true}
            backTo="/admin/rosters/organization_list"
            isLoading={isLoading}
          />
        </div>
      </form>
    </div>
  );
}

export default OrganizationStep5;
